import script from "./MonographForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MonographForm.vue?vue&type=script&setup=true&lang=js"

import "./MonographForm.vue?vue&type=style&index=0&id=68dc8d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68dc8d32"]])

export default __exports__